<script>
export default {
  props: ['formdata'],
  data() {
    return {
      localModel: {},
      initial:true,
    }
  },
  methods: {
    upload() {
      const files = document.getElementById("file").files;
      var _this = this
      for(const file of files) {
        const reader = new FileReader();
        reader.onloadend = () => {
          _this.localModel.servicefoto = reader.result
          _this.localModel.servicefotonaam = reader.fileName
          console.log(reader.fileName); // file name
        };
        reader.fileName = file.name;
        reader.readAsDataURL(file);
      }

    },
    previousStep() {
      this.emitter.emit("step", 2);
    },
    nextStep() {
      if (this.validate()) {
        this.emitter.emit("modelUpdated", this.localModel);
        this.emitter.emit("step", 4);
      }

    },
    validate() {
      if (this.localModel.servicefoto === "" || this.localModel.servicefoto === undefined || this.localModel.servicefoto === null
      )
        return false;
      return true;
    },
  },
  mounted() {
    this.localModel = this.formdata;
  }
}
</script>
<template>

  <!------------ step form Area Start  ----------->
  <section class="step-form">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="step-form-wrapper">
            <div class="contact-form">
              <form action="">
                <div class="step-form-content">
                  <form action="data.php" method="post" class="form">
                    <!-- Progress Bar -->
                    <div class="progress-bar">
                      <div class="progress" id="progress"></div>
                      <div class="progress-step active" data-title="Personal"></div>
                      <div class="progress-step active" data-title="Contact "></div>
                      <div class="progress-step active" data-title="Experiences"></div>
                      <div class="progress-step" data-title="Links"></div>
                    </div>

                    <!-- Steps -->
                    <div class="form-step active">
                      <h3>De schaftwagen(s)</h3>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-form-info">
                                <label for="">Bijzonderheden</label>
                                <textarea v-model="localModel.extra_notes" id="" placeholder="Bijzonderheden"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="single-upload">
                                <div class="single-upload-title">
                                  <h5>Foto <span>{{ localModel.servicefotonaam ? ':':'' }} {{ localModel.servicefotonaam ?? ''}}</span></h5>
                                </div>
                                <div class="upload-box">
                                  <div class="drop_box">
                                    <div class="opload-icon">
                                      <img src="assets/img/upload.svg" alt="">
                                    </div>
                                    <h4>Klik hier om uw bestand te kiezen (JPG, PNG, of PDF)</h4>
                                    <input type="file" id="file" @change="upload" ref="myUploader" accept=".jpg,.jpeg,.png,.pdf" style="display: none">
                                    <button class="btn" @click.prevent="$refs.myUploader.click()"></button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="contact-form-btn contact-form-btn-two">
                  <button class="contact-form-btn-gray" @click.prevent="previousStep">Vorige</button>
                  <button @click.prevent="nextStep">Volgende</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!------------ step form Area End ------------->

</template>

<style scoped>

</style>